<ul class="justify-content-center" [class.mobile]="isMobile" *ngIf="steps && steps.length">
  <ng-container *ngFor="let step of steps; let i = index; trackBy: trackBySteps">
    <li>
      <span class="text-align-center">
        <div class="selected">
          <button class="step" [ngClass]="step.isActive ? 'active' : 'inactive'">
            {{ step.name }}
          </button>
          <div class="step-name">
            {{ step.title | translate }}
          </div>
        </div>
      </span>
    </li>
    <li *ngIf="step !== steps[steps.length - 1]">
      <img *ngIf="step.isActive" src="/assets/img/completed-arrow-steps.svg" />
      <img *ngIf="!step.isActive" src="/assets/img/arrow-steps.svg" />
    </li>
  </ng-container>
</ul>
